import { inject, Injectable } from '@angular/core';
import { collection, Firestore, query, where } from '@angular/fire/firestore';
import { ObservableQueryService } from '@damofire/data-angular-commons';
import { ChangeTyped, REPAIR_MEDIAS_COLLECTION, WW_REPAIRS_COLLECTION } from '@damofire/data-commons';
import { map, Observable } from 'rxjs';
import { ObservableRepairMediaService } from './repair-media-observable.service';
import { RepairMedia } from './repair.dto';

@Injectable()
export class FirebaseObservableRepairMediaService extends ObservableRepairMediaService {
  private readonly firestore = inject(Firestore);

  constructor(private readonly firestoreQueryService: ObservableQueryService) {
    super();
  }

  observeMediaByRepair(division: string, repairId: string): Observable<ChangeTyped<RepairMedia>[]> {
    const q = query(collection(this.firestore, `${WW_REPAIRS_COLLECTION}/${repairId}/${REPAIR_MEDIAS_COLLECTION}`), where('division._id', '==', division));
    return this.firestoreQueryService.observeChanges(q).pipe(map((results) => results.sort((a, b) => Number(b.audit.createdDate) - Number(a.audit.createdDate))));
  }
}
